import axios from "axios"
import { Dispatch, RNBThunkAction } from "../store.config"
import { RootState } from "../rootReducer"
import { AnyAction } from "redux"
import { ThunkDispatch } from "redux-thunk"
import {
  ArchivesPayload,
  BankArchivesActionsEnum,
  BankArchivesActionsType,
  GenerationStatus,
  newOperationsWithoutArchive,
} from "./bankArchives.ducks"
import {
  BatchDataAttached,
  FullDocumentToAttach,
  FullDocumentsActionsEnum,
  FullDocumentsActionsType,
  GetDocumentsToAttachToTransactionsThunk,
} from "./fullDocuments.ducks"
import { DropDocumentResultPayload, signRequest } from "./dropDocuments.ducks"
import { fileExtensionOfString } from "../../utils/string"
import { acceptedBatchExtensions } from "../../utils/file"
import { validateUrl } from "../../utils/url"
import { BankItem } from "../../utils/bank"

const enum BankActionsEnum {
  RESET_BANK_ACCOUNT_DATA = "BANK/resetBankAccountData",

  GET_COMPANY_BANKS_ITEMS_ATTEMPT = "BANK/getCompanyBanksItemsAttempt",
  GET_COMPANY_BANKS_ITEMS_SUCCESS = "BANK/getCompanyBanksItemsSuccess",
  GET_COMPANY_BANKS_ITEMS_FAILURE = "BANK/getCompanyBanksItemsFailure",

  GET_LIST_BANKS_ATTEMPT = "BANK/getListBanksAttempt",
  GET_LIST_BANKS_SUCCESS = "BANK/getListBanksSuccess",
  GET_LIST_BANKS_FAILURE = "BANK/getListBanksFailure",

  ADD_BANK_ATTEMPT = "BANK/addBankAttempt",
  ADD_BANK_SUCCESS_ACTION = "BANK/addBankSuccessAction",
  ADD_BANK_FAILURE_ACTION = "BANK/addBankFailureAction",

  SYNC_ERROR_ATTEMPT = "BANK/sync_errorAttemptAction",
  SYNC_ERROR_FAILURE = "BANK/sync_errorFailureAction",
  SYNC_ERROR_SUCCESS = "BANK/sync_errorSuccessAction",

  VALIDATE_PRO_ITEM_ATTEMPT = "BANK/validateProItemAttempt",
  VALIDATE_PRO_ITEM_SUCCESS = "BANK/validateProItemSuccess",
  VALIDATE_PRO_ITEM_FAILURE = "BANK/validateProItemFailure",

  DEACTIVATE_ITEM_ATTEMPT = "BANK/deactivateItemAttempt",
  DEACTIVATE_ITEM_SUCCESS = "BANK/deactivateItemSuccess",
  DEACTIVATE_ITEM_FAILURE = "BANK/deactivateItemFailure",
  DEACTIVATE_ITEM_RESET = "BANK/deactivateItemReset",

  DEACTIVATE_ACCOUNT_ATTEMPT = "BANK/deactivateAccountAttempt",
  DEACTIVATE_ACCOUNT_SUCCESS = "BANK/deactivateAccountSuccess",
  DEACTIVATE_ACCOUNT_FAILURE = "BANK/deactivateAccountFailure",
  DEACTIVATE_ACCOUNT_RESET = "BANK/deactivateAccountReset",

  UPDATE_ACCOUNT_SETTINGS_ATTEMPT = "BANK/updateAccountSettingsAttempt",
  UPDATE_ACCOUNT_SETTINGS_SUCCESS = "BANK/updateAccountSettingsSuccess",
  UPDATE_ACCOUNT_SETTINGS_FAILURE = "BANK/updateAccountSettingsFailure",
  UPDATE_ACCOUNT_SETTINGS_RESET = "BANK/updateAccountSettingsReset",

  GET_RULES_ATTEMPT = "BANK/GetRulesAttempt",
  GET_RULES_SUCCESS = "BANK/GetRulesSuccess",
  GET_RULES_FAILURE = "BANK/GetRulesFailure",

  GET_RULES_WITHOUT_DOCUMENT_ATTEMPT = "BANK/GetRulesWithoutDocumentAttempt",
  GET_RULES_WITHOUT_DOCUMENT_SUCCESS = "BANK/GetRulesWithoutDocumentSuccess",
  GET_RULES_WITHOUT_DOCUMENT_FAILURE = "BANK/GetRulesWithoutDocumentFailure",

  GET_DATA_TO_CREATE_RULE_ATTEMPT = "BANK/GetDataToCreateRuleAttempt",
  GET_DATA_TO_CREATE_RULE_SUCCESS = "BANK/GetDataToCreateRuleSuccess",
  GET_DATA_TO_CREATE_RULE_FAILURE = "BANK/GetDataToCreateRuleFailure",

  CREATE_RULE_ATTEMPT = "BANK/CreateRuleAttempt",
  CREATE_RULE_SUCCESS = "BANK/CreateRuleSuccess",
  CREATE_RULE_FAILURE = "BANK/CreateRuleFailure",

  CREATE_OR_EDIT_RULE_RESET = "BANK/CreateOrEditRuleReset",

  EDIT_RULE_ATTEMPT = "BANK/EditRuleAttempt",
  EDIT_RULE_SUCCESS = "BANK/EditRuleSuccess",
  EDIT_RULE_FAILURE = "BANK/EditRuleFailure",

  GET_RULES_EVENTS_ATTEMPT = "BANK/GetRuleEventsAttempt",
  GET_RULES_EVENTS_SUCCESS = "BANK/GetRuleEventsSuccess",
  GET_RULES_WITHOUT_DOCUMENTS_EVENTS_SUCCESS = "BANK/GetRuleWithoutDocumentEventsSuccess",
  GET_RULES_EVENTS_FAILURE = "BANK/GetRuleEventsFailure",

  DELETE_RULE_ATTEMPT = "BANK/DeleteRuleAttempt",
  DELETE_RULE_SUCCESS = "BANK/DeleteRuleSuccess",
  DELETE_RULE_FAILURE = "BANK/DeleteRuleFailure",

  GET_TRANSACTIONS_RESET = "BANK/GetTranscationsReset",
  GET_TRANSACTIONS_ATTEMPT = "BANK/GetTranscationsAttempt",
  GET_TRANSACTIONS_SUCCESS = "BANK/GetTranscationsSuccess",
  GET_TRANSACTIONS_FAILURE = "BANK/GetTranscationsFailure",

  TRANSFER_TO_ANOTHER_ACCOUNT_ATTEMPT = "BANK/TransferToAnotherAccountAttempt",
  TRANSFER_TO_ANOTHER_ACCOUNT_SUCCESS = "BANK/TransferToAnotherAccountSuccess",
  TRANSFER_TO_ANOTHER_ACCOUNT_FAILURE = "BANK/TransferToAnotherAccountFailure",

  CREATE_RULE_FOR_ONE_TRANSACTION_ATTEMPT = "BANK/CreateRuleForOneTransactionAttempt",
  CREATE_RULE_FOR_ONE_TRANSACTION_SUCCESS = "BANK/CreateRuleForOneTransactionSuccess",
  CREATE_RULE_FOR_ONE_TRANSACTION_FAILURE = "BANK/CreateRuleForOneTransactionFailure",

  MARK_WITHOUT_DOCUMENT_ATTEMPT = "BANK/MarkWithoutDocumentAttempt",
  MARK_WITHOUT_DOCUMENT_SUCCESS = "BANK/MarkWithoutDocumentSuccess",
  MARK_WITHOUT_DOCUMENT_FAILURE = "BANK/MarkWithoutDocumentFailure",

  GET_TRANSACTION_EVENTS_ATTEMPT = "BANK/GetTransactionEventsAttempt",
  GET_TRANSACTION_EVENTS_SUCCESS = "BANK/GetTransactionEventsSuccess",

  DROP_BATCH_FOR_TRANSACTION_ATTEMPT = "BANK/DropBatchForTransactionAttempt",
  DROP_BATCH_FOR_TRANSACTION_SUCCESS = "BANK/DropBatchForTransactionSuccess",
  DROP_BATCH_FOR_TRANSACTION_FAILURE = "BANK/DropBatchForTransactionFailure",

  ATTACH_BATCH_ON_TRANSACTION_ATTEMPT = "BANK/AttachBatchOnTransactionAttempt",
  ATTACH_BATCH_ON_TRANSACTION_SUCCESS = "BANK/AttachBatchOnTransactionSuccess",
  ATTACH_BATCH_ON_TRANSACTION_FAILURE = "BANK/AttachBatchOnTransactionFailure",

  GET_URL_FULL_DOCUMENT_ATTEMPT = "BANK/getUrlFullDocumentAttempt",
  GET_URL_FULL_DOCUMENT_SUCCESS = "BANK/getUrlFullDocumentSuccess",
  GET_URL_FULL_DOCUMENT_FAILURE = "BANK/getUrlFullDocumentFailure",

  CREATE_ITEM_WITHOUT_BANKIN_ATTEMPT = "BANK/createItemWithoutBankinAttempt",
  CREATE_ITEM_WITHOUT_BANKIN_SUCCESS = "BANK/createItemWithoutBankinSuccess",
  CREATE_ITEM_WITHOUT_BANKIN_FAILURE = "BANK/createItemWithoutBankinFailure",

  CREATE_ACCOUNT_WITHOUT_BANKIN_ATTEMPT = "BANK/createAccountWithoutBankinAttempt",
  CREATE_ACCOUNT_WITHOUT_BANKIN_SUCCESS = "BANK/createAccountWithoutBankinSuccess",
  CREATE_ACCOUNT_WITHOUT_BANKIN_FAILURE = "BANK/createAccountWithoutBankinFailure",

  UPDATE_TRANSACTION_USER_DESCRIPTION_ATTEMPT = "BANK/UpdateTransactionUserDescriptionAttempt",
  UPDATE_TRANSACTION_USER_DESCRIPTION_SUCCESS = "BANK/UpdateTransactionUserDescriptionSuccess",
  UPDATE_TRANSACTION_USER_DESCRIPTION_FAILURE = "BANK/UpdateTransactionUserDescriptionFailure",
  UPDATE_TRANSACTION_USER_DESCRIPTION_RESET = "BANK/UpdateTransactionUserDescriptionReset",
}

export const resetBankAccountDataAction = () =>
  ({ type: BankActionsEnum.RESET_BANK_ACCOUNT_DATA } as const)

export const getCompanyBanksItemsAttemptAction = () =>
  ({ type: BankActionsEnum.GET_COMPANY_BANKS_ITEMS_ATTEMPT } as const)
export const getCompanyBanksItemsSuccessAction = (payload: BankItem[]) =>
  ({ type: BankActionsEnum.GET_COMPANY_BANKS_ITEMS_SUCCESS, payload } as const)
export const getCompanyBanksItemsFailureAction = () =>
  ({ type: BankActionsEnum.GET_COMPANY_BANKS_ITEMS_FAILURE } as const)

export const addBankAttemptAction = () =>
  ({ type: BankActionsEnum.ADD_BANK_ATTEMPT } as const)
export const addBankSuccessAction = () =>
  ({ type: BankActionsEnum.ADD_BANK_SUCCESS_ACTION } as const)
export const addBankFailureAction = () =>
  ({
    type: BankActionsEnum.ADD_BANK_FAILURE_ACTION,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "Erreur",
      bodyKey: "Veuillez contacter l'équipe Chaintrust",
    },
  } as const)

export const syncErrorAttemptAction = () =>
  ({ type: BankActionsEnum.SYNC_ERROR_ATTEMPT } as const)
export const syncErrorFailureAction = () =>
  ({ type: BankActionsEnum.SYNC_ERROR_FAILURE } as const)
export const syncErrorSuccessAction = () =>
  ({ type: BankActionsEnum.SYNC_ERROR_SUCCESS } as const)

export const validateProItemAttemptAction = () =>
  ({ type: BankActionsEnum.VALIDATE_PRO_ITEM_ATTEMPT } as const)
export const validateProItemSuccessAction = () =>
  ({ type: BankActionsEnum.VALIDATE_PRO_ITEM_SUCCESS } as const)
export const validateProItemFailureAction = () =>
  ({ type: BankActionsEnum.VALIDATE_PRO_ITEM_FAILURE } as const)

export const deactivateItemAttempt = () =>
  ({ type: BankActionsEnum.DEACTIVATE_ITEM_ATTEMPT } as const)
export const deactivateItemSuccess = () =>
  ({
    type: BankActionsEnum.DEACTIVATE_ITEM_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.delete.toast.success.title`,
      titleValues: {
        accountOrBank: "Banque",
        gender: "supprimée",
      },
      bodyKey: `bank-management.delete.toast.success.body`,
      bodyValues: {
        accountOrBank: "Banque",
        gender: "supprimée",
      },
    },
  } as const)
export const deactivateItemFailure = () =>
  ({
    type: BankActionsEnum.DEACTIVATE_ITEM_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.delete.toast.error.title`,
      bodyKey: `bank-management.delete.toast.error.body`,
      bodyValues: {
        accountOrBank: "banque",
        gender: "supprimée",
      },
    },
  } as const)
export const deactivateItemReset = () =>
  ({ type: BankActionsEnum.DEACTIVATE_ITEM_RESET } as const)

export const deactivateAccountAttempt = () =>
  ({ type: BankActionsEnum.DEACTIVATE_ACCOUNT_ATTEMPT } as const)
export const deactivateAccountSuccess = () =>
  ({
    type: BankActionsEnum.DEACTIVATE_ACCOUNT_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.delete.toast.success.title`,
      titleValues: {
        accountOrBank: "Compte",
        gender: "supprimé",
      },
      bodyKey: `bank-management.delete.toast.success.body`,
      bodyValues: {
        accountOrBank: "Compte",
        gender: "supprimé",
      },
    },
  } as const)
export const deactivateAccountFailure = () =>
  ({
    type: BankActionsEnum.DEACTIVATE_ACCOUNT_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.delete.toast.error.title`,
      bodyKey: `bank-management.delete.toast.error.body`,
      bodyValues: {
        accountOrBank: "compte",
        gender: "supprimé",
      },
    },
  } as const)
export const deactivateAccountReset = () =>
  ({ type: BankActionsEnum.DEACTIVATE_ACCOUNT_RESET } as const)

export const updateAccountSettingsAttempt = () =>
  ({ type: BankActionsEnum.UPDATE_ACCOUNT_SETTINGS_ATTEMPT } as const)
export const updateAccountSettingsSuccess = () =>
  ({
    type: BankActionsEnum.UPDATE_ACCOUNT_SETTINGS_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.account-modification.toast.success.title`,
      bodyKey: `bank-management.account-modification.toast.success.body`,
    },
  } as const)
export const updateAccountSettingsFailure = (errorMessage: string) =>
  ({
    type: BankActionsEnum.UPDATE_ACCOUNT_SETTINGS_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.account-modification.toast.error.title`,
      bodyKey: "bank-management.name-modification.toast.error.body.point",
      bodyValues: {
        errorMessage: errorMessage,
      },
    },
  } as const)
export const updateAccountSettingsReset = () =>
  ({ type: BankActionsEnum.UPDATE_ACCOUNT_SETTINGS_RESET } as const)

export const GetRulesAttempt = () =>
  ({ type: BankActionsEnum.GET_RULES_ATTEMPT } as const)
export const GetRulesSuccess = (bankAccountId: number, rules: AccountRules[]) =>
  ({ type: BankActionsEnum.GET_RULES_SUCCESS, bankAccountId, rules } as const)
export const GetRulesFailure = () =>
  ({ type: BankActionsEnum.GET_RULES_FAILURE } as const)

export const GetRulesWithoutDocumentAttempt = () =>
  ({ type: BankActionsEnum.GET_RULES_WITHOUT_DOCUMENT_ATTEMPT } as const)
export const GetRulesWithoutDocumentSuccess = (
  bankAccountId: number,
  rules: AccountRulesWithoutDocument[]
) =>
  ({
    type: BankActionsEnum.GET_RULES_WITHOUT_DOCUMENT_SUCCESS,
    bankAccountId,
    rules,
  } as const)
export const GetRulesWithoutDocumentFailure = () =>
  ({ type: BankActionsEnum.GET_RULES_WITHOUT_DOCUMENT_FAILURE } as const)

export const GetDataToCreateRuleAttempt = () =>
  ({ type: BankActionsEnum.GET_DATA_TO_CREATE_RULE_ATTEMPT } as const)
export const GetDataToCreateRuleSuccess = (data: DataToCreateRule) =>
  ({ type: BankActionsEnum.GET_DATA_TO_CREATE_RULE_SUCCESS, data } as const)
export const GetDataToCreateRuleFailure = () =>
  ({ type: BankActionsEnum.GET_DATA_TO_CREATE_RULE_FAILURE } as const)

export const CreateRuleAttempt = () =>
  ({ type: BankActionsEnum.CREATE_RULE_ATTEMPT } as const)
export const CreateRuleSuccess = () =>
  ({
    type: BankActionsEnum.CREATE_RULE_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.rules.add-rule.success.title`,
      bodyKey: `bank-management.rules.add-rule.success.message`,
    },
  } as const)
export const CreateRuleFailure = (bodyKey: string) =>
  ({
    type: BankActionsEnum.CREATE_RULE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.rules.add-rule.error.title`,
      bodyKey: bodyKey,
    },
  } as const)
export const CreateOrEditRuleReset = () =>
  ({
    type: BankActionsEnum.CREATE_OR_EDIT_RULE_RESET,
  } as const)

export const EditRuleAttempt = () =>
  ({
    type: BankActionsEnum.EDIT_RULE_ATTEMPT,
  } as const)
export const EditRuleSuccess = () =>
  ({
    type: BankActionsEnum.EDIT_RULE_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.rules.edit-rule.success.title`,
      bodyKey: `bank-management.rules.edit-rule.success.message`,
    },
  } as const)
export const EditRuleFailure = (bodyKey: string) =>
  ({
    type: BankActionsEnum.EDIT_RULE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.rules.edit-rule.error.title`,
      bodyKey: bodyKey,
    },
  } as const)

export const GetRuleEventsAttempt = () =>
  ({
    type: BankActionsEnum.GET_RULES_EVENTS_ATTEMPT,
  } as const)
export const GetRuleEventsSuccess = (
  events: RuleEvent[],
  bankAccountId: number,
  ruleId: number
) =>
  ({
    type: BankActionsEnum.GET_RULES_EVENTS_SUCCESS,
    events,
    bankAccountId,
    ruleId,
  } as const)
export const GetRuleWithoutDocumentEventsSuccess = (
  events: RuleEvent[],
  bankAccountId: number,
  ruleId: number
) =>
  ({
    type: BankActionsEnum.GET_RULES_WITHOUT_DOCUMENTS_EVENTS_SUCCESS,
    events,
    bankAccountId,
    ruleId,
  } as const)
export const GetRuleEventsFailure = () =>
  ({
    type: BankActionsEnum.GET_RULES_EVENTS_FAILURE,
  } as const)

export const DeleteRuleAttempt = () =>
  ({
    type: BankActionsEnum.DELETE_RULE_ATTEMPT,
  } as const)
export const DeleteRuleSuccess = (rule_without_document: boolean) =>
  ({
    type: BankActionsEnum.DELETE_RULE_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.rules.delete-rule.delete.success.tilte`,
      bodyKey: rule_without_document
        ? "bank-management.rules.delete-rule-without-document.delete.success.message"
        : "bank-management.rules.delete-rule.delete.success.message",
    },
  } as const)
export const DeleteRuleFailure = () =>
  ({
    type: BankActionsEnum.DELETE_RULE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.rules.delete-rule.delete.error.title`,
      bodyKey: "bank-management.rules.delete-rule.delete.error.message",
    },
  } as const)

export const GetTranscationsReset = (bankAccountId: number) =>
  ({
    type: BankActionsEnum.GET_TRANSACTIONS_RESET,
    bankAccountId,
  } as const)
export const GetTranscationsAttempt = (bankAccountId: number) =>
  ({
    type: BankActionsEnum.GET_TRANSACTIONS_ATTEMPT,
    bankAccountId,
  } as const)
export const GetTranscationsSuccess = (
  transactions: Transaction[],
  transations_need_action: { transaction_id: number; need_action: boolean }[],
  bankAccountId: number,
  resetTransactions: boolean
) =>
  ({
    type: BankActionsEnum.GET_TRANSACTIONS_SUCCESS,
    transactions,
    transations_need_action,
    bankAccountId,
    resetTransactions,
  } as const)
export const GetTranscationsFailure = () =>
  ({
    type: BankActionsEnum.GET_TRANSACTIONS_FAILURE,
  } as const)

export const TransferToAnotherAccountAttempt = () =>
  ({
    type: BankActionsEnum.TRANSFER_TO_ANOTHER_ACCOUNT_ATTEMPT,
  } as const)
export const TransferToAnotherAccountSuccess = () =>
  ({
    type: BankActionsEnum.TRANSFER_TO_ANOTHER_ACCOUNT_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.rules.transfer-rules.transfer.success-title`,
      bodyKey: "bank-management.rules.transfer-rules.transfer.success-message",
    },
  } as const)
export const TransferToAnotherAccountFailure = () =>
  ({
    type: BankActionsEnum.TRANSFER_TO_ANOTHER_ACCOUNT_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.rules.transfer-rules.transfer.error-title`,
      bodyKey: "bank-management.rules.transfer-rules.transfer.error-message",
    },
  } as const)

export const CreateRuleForOneTransactionAttempt = () =>
  ({
    type: BankActionsEnum.CREATE_RULE_FOR_ONE_TRANSACTION_ATTEMPT,
  } as const)
export const CreateRuleForOneTransactionSuccess = () =>
  ({
    type: BankActionsEnum.CREATE_RULE_FOR_ONE_TRANSACTION_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.rules.add-rule-on-transaction.success.title`,
      bodyKey: `bank-management.rules.add-rule-on-transaction.success.message`,
    },
  } as const)
export const CreateRuleForOneTransactionFailure = () =>
  ({
    type: BankActionsEnum.CREATE_RULE_FOR_ONE_TRANSACTION_FAILURE,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.rules.add-rule-on-transaction.error.title`,
      bodyKey: `bank-management.rules.add-rule-on-transaction.error.message`,
    },
  } as const)

export const MarkWithoutDocumentAttempt = () =>
  ({
    type: BankActionsEnum.MARK_WITHOUT_DOCUMENT_ATTEMPT,
  } as const)
export const MarkWithoutDocumentSuccess = (marked_without_document: boolean) =>
  ({
    type: BankActionsEnum.MARK_WITHOUT_DOCUMENT_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.rules-without-document.marked_without_document.success.title`,
      bodyKey: `bank-management.rules-without-document.marked_without_document.success.message`,
      bodyValues: {
        withOrWithout: marked_without_document ? "sans" : "avec",
      },
    },
  } as const)
export const MarkWithoutDocumentFailure = (message: string) =>
  ({
    type: BankActionsEnum.MARK_WITHOUT_DOCUMENT_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.rules-without-document.marked_without_document.error.title`,
      bodyKey: message,
    },
  } as const)

export const GetTransactionEventsAttempt = () =>
  ({
    type: BankActionsEnum.GET_TRANSACTION_EVENTS_ATTEMPT,
  } as const)
export const GetTransactionEventsSuccess = (
  events: TransactionEvent[],
  accountID: number,
  transactionId: number
) =>
  ({
    type: BankActionsEnum.GET_TRANSACTION_EVENTS_SUCCESS,
    events,
    accountID,
    transactionId,
  } as const)

export const DropBatchForTransactionAttempt = () =>
  ({
    type: BankActionsEnum.DROP_BATCH_FOR_TRANSACTION_ATTEMPT,
  } as const)
export const DropBatchForTransactionSuccess = (
  bankAccountId: number,
  transactionId: number,
  batch_document_id: number
) =>
  ({
    type: BankActionsEnum.DROP_BATCH_FOR_TRANSACTION_SUCCESS,
    bankAccountId,
    transactionId,
    batch_document_id,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.transaction.attach-modal.drop-batch-tooltip-success.title`,
      bodyKey: `bank-management.transaction.attach-modal.drop-batch-tooltip-success.message`,
    },
  } as const)
export const DropBatchForTransactionFailure = () =>
  ({
    type: BankActionsEnum.DROP_BATCH_FOR_TRANSACTION_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.transaction.attach-modal.drop-batch-tooltip-error.title`,
      bodyKey: `bank-management.transaction.attach-modal.drop-batch-tooltip-error.message`,
    },
  } as const)

export const AttachBatchOnTransactionAttempt = () =>
  ({
    type: BankActionsEnum.ATTACH_BATCH_ON_TRANSACTION_ATTEMPT,
  } as const)
export const AttachBatchOnTransactionSuccess = () =>
  ({
    type: BankActionsEnum.ATTACH_BATCH_ON_TRANSACTION_SUCCESS,
  } as const)
export const AttachBatchOnTransactionFailure = () =>
  ({
    type: BankActionsEnum.ATTACH_BATCH_ON_TRANSACTION_FAILURE,
  } as const)

export const getUrlFullDocumentAttempt = () =>
  ({
    type: BankActionsEnum.GET_URL_FULL_DOCUMENT_ATTEMPT,
  } as const)
export const getUrlFullDocumentSuccess = (payload: string) =>
  ({
    type: BankActionsEnum.GET_URL_FULL_DOCUMENT_SUCCESS,
    payload,
  } as const)
export const getUrlFullDocumentFailure = () =>
  ({
    type: BankActionsEnum.GET_URL_FULL_DOCUMENT_FAILURE,
  } as const)

export const getListBanksAttempt = () =>
  ({
    type: BankActionsEnum.GET_LIST_BANKS_ATTEMPT,
  } as const)
export const getListBanksSuccess = (listBanks: ListBank[]) =>
  ({
    type: BankActionsEnum.GET_LIST_BANKS_SUCCESS,
    listBanks,
  } as const)
export const getListBanksFailure = () =>
  ({
    type: BankActionsEnum.GET_LIST_BANKS_FAILURE,
  } as const)

export const createItemWithoutBankinAttempt = () =>
  ({
    type: BankActionsEnum.CREATE_ITEM_WITHOUT_BANKIN_ATTEMPT,
  } as const)
export const createItemWithoutBankinSuccess = () =>
  ({
    type: BankActionsEnum.CREATE_ITEM_WITHOUT_BANKIN_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank.bank-statement.create.tooltip.success.title`,
      bodyKey: "bank.bank-statement.create.tooltip.success.message",
    },
  } as const)
export const createItemWithoutBankinFailure = (errorMessage: string) =>
  ({
    type: BankActionsEnum.CREATE_ITEM_WITHOUT_BANKIN_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.account-modification.toast.error.title`,
      bodyKey: "bank-management.name-modification.toast.error.body.point",
      bodyValues: {
        errorMessage: errorMessage,
      },
    },
  } as const)

export const createAccountWithoutBankinAttempt = () =>
  ({
    type: BankActionsEnum.CREATE_ACCOUNT_WITHOUT_BANKIN_ATTEMPT,
  } as const)
export const createAccountWithoutBankinSuccess = () =>
  ({
    type: BankActionsEnum.CREATE_ACCOUNT_WITHOUT_BANKIN_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank.bank-statement.create-account.tooltip.success.title`,
      bodyKey: "bank.bank-statement.create-account.tooltip.success.message",
    },
  } as const)
export const createAccountWithoutBankinFailure = (errorMessage: string) =>
  ({
    type: BankActionsEnum.CREATE_ACCOUNT_WITHOUT_BANKIN_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.account-modification.toast.error.title`,
      bodyKey: "bank-management.name-modification.toast.error.body.point",
      bodyValues: {
        errorMessage: errorMessage,
      },
    },
  } as const)

export const updateTransactionUserDescriptionAttempt = () =>
  ({
    type: BankActionsEnum.UPDATE_TRANSACTION_USER_DESCRIPTION_ATTEMPT,
  } as const)
export const updateTransactionUserDescriptionSuccess = () =>
  ({
    type: BankActionsEnum.UPDATE_TRANSACTION_USER_DESCRIPTION_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `bank-management.transaction.detail.toast.success.title`,
      bodyKey: `bank-management.transaction.detail.toast.success.message`,
    },
  } as const)
export const updateTransactionUserDescriptionFailure = () =>
  ({
    type: BankActionsEnum.UPDATE_TRANSACTION_USER_DESCRIPTION_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `bank-management.transaction.detail.toast.error.title`,
      bodyKey: `bank-management.transaction.detail.toast.error.message`,
    },
  } as const)

export const updateTransactionUserDescriptionReset = () =>
  ({
    type: BankActionsEnum.UPDATE_TRANSACTION_USER_DESCRIPTION_RESET,
  } as const)

type BankActionsType = ReturnType<
  | typeof resetBankAccountDataAction
  | typeof getCompanyBanksItemsAttemptAction
  | typeof getCompanyBanksItemsSuccessAction
  | typeof getCompanyBanksItemsFailureAction
  | typeof addBankAttemptAction
  | typeof addBankSuccessAction
  | typeof addBankFailureAction
  | typeof syncErrorAttemptAction
  | typeof syncErrorFailureAction
  | typeof syncErrorSuccessAction
  | typeof validateProItemAttemptAction
  | typeof validateProItemSuccessAction
  | typeof validateProItemFailureAction
  | typeof deactivateItemAttempt
  | typeof deactivateItemSuccess
  | typeof deactivateItemFailure
  | typeof deactivateItemReset
  | typeof deactivateAccountAttempt
  | typeof deactivateAccountSuccess
  | typeof deactivateAccountFailure
  | typeof deactivateAccountReset
  | typeof updateAccountSettingsAttempt
  | typeof updateAccountSettingsSuccess
  | typeof updateAccountSettingsFailure
  | typeof updateAccountSettingsReset
  | typeof GetRulesAttempt
  | typeof GetRulesSuccess
  | typeof GetRulesFailure
  | typeof GetRulesWithoutDocumentAttempt
  | typeof GetRulesWithoutDocumentSuccess
  | typeof GetRulesWithoutDocumentFailure
  | typeof GetDataToCreateRuleAttempt
  | typeof GetDataToCreateRuleSuccess
  | typeof GetDataToCreateRuleFailure
  | typeof CreateRuleAttempt
  | typeof CreateRuleSuccess
  | typeof CreateRuleFailure
  | typeof CreateOrEditRuleReset
  | typeof EditRuleAttempt
  | typeof EditRuleSuccess
  | typeof EditRuleFailure
  | typeof GetRuleEventsAttempt
  | typeof GetRuleEventsSuccess
  | typeof GetRuleWithoutDocumentEventsSuccess
  | typeof GetRuleEventsFailure
  | typeof DeleteRuleAttempt
  | typeof DeleteRuleSuccess
  | typeof DeleteRuleFailure
  | typeof GetTranscationsReset
  | typeof GetTranscationsAttempt
  | typeof GetTranscationsSuccess
  | typeof GetTranscationsFailure
  | typeof TransferToAnotherAccountAttempt
  | typeof TransferToAnotherAccountSuccess
  | typeof TransferToAnotherAccountFailure
  | typeof CreateRuleForOneTransactionAttempt
  | typeof CreateRuleForOneTransactionSuccess
  | typeof CreateRuleForOneTransactionFailure
  | typeof MarkWithoutDocumentAttempt
  | typeof MarkWithoutDocumentSuccess
  | typeof MarkWithoutDocumentFailure
  | typeof GetTransactionEventsAttempt
  | typeof GetTransactionEventsSuccess
  | typeof DropBatchForTransactionAttempt
  | typeof DropBatchForTransactionSuccess
  | typeof DropBatchForTransactionFailure
  | typeof AttachBatchOnTransactionAttempt
  | typeof AttachBatchOnTransactionSuccess
  | typeof AttachBatchOnTransactionFailure
  | typeof getUrlFullDocumentAttempt
  | typeof getUrlFullDocumentSuccess
  | typeof getUrlFullDocumentFailure
  | typeof getListBanksAttempt
  | typeof getListBanksSuccess
  | typeof getListBanksFailure
  | typeof createItemWithoutBankinAttempt
  | typeof createItemWithoutBankinSuccess
  | typeof createItemWithoutBankinFailure
  | typeof createAccountWithoutBankinAttempt
  | typeof createAccountWithoutBankinSuccess
  | typeof createAccountWithoutBankinFailure
  | typeof updateTransactionUserDescriptionAttempt
  | typeof updateTransactionUserDescriptionSuccess
  | typeof updateTransactionUserDescriptionFailure
  | typeof updateTransactionUserDescriptionReset
>

export interface BankState {
  listBanks: ListBank[]
  bankItems: BankItem[]
  rules: AccountRules[]
  rulesWithoutDocument: AccountRulesWithoutDocument[]
  transactions: Transaction[]
  archives: ArchivesPayload[]
  newOperationsWithoutArchive: newOperationsWithoutArchive[]
  dataToCreateRule: DataToCreateRule
  urlFullDocumentToAttach: string
  documentsToAttach: {
    full_documents: FullDocumentToAttach[]
    batch_data: BatchDataAttached | null
  }
  transactionDateBounds: { min_date: string; max_date: string } | null
  activationState: "DEFAULT" | "REQUESTED" | "ACTIVATED" | null
  bankItemsLoading: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  getArchivesStatus: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  downloadingStatus:
    | "IDLE"
    | "ATTEMPT"
    | "DOWNLOADING"
    | "DOWNLOADED"
    | "FAILURE"
  regenerateBankArchiveStatus: "IDLE" | "LOADING" | "SUCCESS" | "ERROR"
  deleteBankArchiveStatus: "IDLE" | "LOADING" | "SUCCESS" | "ERROR"
  operationsStatus: "DEFAULT" | "LOADING" | "LOADED" | "ERROR"
  deactivateAccountStatus: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  deactivateItemStatus: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  updateAccountStatus: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  createOrEditRuleStatus: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  getTransactionsStatus: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  transferToStatus: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  attachDocumentStatus: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  getUrlFullDocumentToAttachStatus: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  createAccountStatus: "IDLE" | "ATTEMPT" | "SUCCESS" | "FAILURE"
  updateTransactionUserDescriptionStatus:
    | "IDLE"
    | "ATTEMPT"
    | "SUCCESS"
    | "FAILURE"
}

const dataToCreateRuleInitialState = {
  merchant_codes: [],
  accounts: [],
  vat_rates: [],
  company_data: {
    buy_auxiliary_prefix: null,
    sell_auxiliary_prefix: null,
    buy_third_party_account: null,
    sell_third_party_account: null,
  },
  rules: [],
  rules_without_document: [],
}

export const bankInitialState: BankState = {
  listBanks: [],
  bankItems: [],
  rules: [],
  rulesWithoutDocument: [],
  transactions: [],
  archives: [],
  newOperationsWithoutArchive: [],
  dataToCreateRule: dataToCreateRuleInitialState,
  urlFullDocumentToAttach: "",
  documentsToAttach: { full_documents: [], batch_data: null },
  transactionDateBounds: null,
  activationState: null,
  bankItemsLoading: "IDLE",
  getArchivesStatus: "IDLE",
  downloadingStatus: "IDLE",
  regenerateBankArchiveStatus: "IDLE",
  deleteBankArchiveStatus: "IDLE",
  operationsStatus: "DEFAULT",
  deactivateAccountStatus: "IDLE",
  deactivateItemStatus: "IDLE",
  updateAccountStatus: "IDLE",
  createOrEditRuleStatus: "IDLE",
  getTransactionsStatus: "IDLE",
  transferToStatus: "IDLE",
  attachDocumentStatus: "IDLE",
  getUrlFullDocumentToAttachStatus: "IDLE",
  createAccountStatus: "IDLE",
  updateTransactionUserDescriptionStatus: "IDLE",
}

export function bankReducer(
  state = bankInitialState,
  action: BankActionsType | BankArchivesActionsType | FullDocumentsActionsType
): BankState {
  switch (action.type) {
    case BankActionsEnum.RESET_BANK_ACCOUNT_DATA:
      return {
        ...state,
        rules: [],
        rulesWithoutDocument: [],
        transactions: [],
        archives: [],
        newOperationsWithoutArchive: [],
        dataToCreateRule: dataToCreateRuleInitialState,
        urlFullDocumentToAttach: "",
        documentsToAttach: { full_documents: [], batch_data: null },
      }

    case BankActionsEnum.GET_COMPANY_BANKS_ITEMS_ATTEMPT:
      return { ...state, bankItemsLoading: "ATTEMPT" }
    case BankActionsEnum.GET_COMPANY_BANKS_ITEMS_SUCCESS:
      return {
        ...state,
        bankItemsLoading: "SUCCESS",
        bankItems: action.payload,
      }
    case BankActionsEnum.GET_COMPANY_BANKS_ITEMS_FAILURE:
      return { ...state, bankItemsLoading: "FAILURE" }

    case BankActionsEnum.DEACTIVATE_ITEM_ATTEMPT:
      return { ...state, deactivateItemStatus: "ATTEMPT" }
    case BankActionsEnum.DEACTIVATE_ITEM_SUCCESS:
      return { ...state, deactivateItemStatus: "SUCCESS" }
    case BankActionsEnum.DEACTIVATE_ITEM_FAILURE:
      return { ...state, deactivateItemStatus: "FAILURE" }
    case BankActionsEnum.DEACTIVATE_ITEM_RESET:
      return { ...state, deactivateItemStatus: "IDLE" }

    case BankActionsEnum.DEACTIVATE_ACCOUNT_ATTEMPT:
      return { ...state, deactivateAccountStatus: "ATTEMPT" }
    case BankActionsEnum.DEACTIVATE_ACCOUNT_SUCCESS:
      return { ...state, deactivateAccountStatus: "SUCCESS" }
    case BankActionsEnum.DEACTIVATE_ACCOUNT_FAILURE:
      return { ...state, deactivateAccountStatus: "FAILURE" }
    case BankActionsEnum.DEACTIVATE_ACCOUNT_RESET:
      return { ...state, deactivateAccountStatus: "IDLE" }

    case BankActionsEnum.UPDATE_ACCOUNT_SETTINGS_ATTEMPT:
      return { ...state, updateAccountStatus: "ATTEMPT" }
    case BankActionsEnum.UPDATE_ACCOUNT_SETTINGS_SUCCESS:
      return { ...state, updateAccountStatus: "SUCCESS" }
    case BankActionsEnum.UPDATE_ACCOUNT_SETTINGS_FAILURE:
      return { ...state, updateAccountStatus: "FAILURE" }
    case BankActionsEnum.UPDATE_ACCOUNT_SETTINGS_RESET:
      return { ...state, updateAccountStatus: "IDLE" }

    case BankArchivesActionsEnum.GET_ARCHIVES_ATTEMPT:
      return { ...state, getArchivesStatus: "ATTEMPT" }
    case BankArchivesActionsEnum.GET_ARCHIVES_SUCCESS: {
      return {
        ...state,
        getArchivesStatus: "SUCCESS",
        archives: action.payload,
      }
    }
    case BankArchivesActionsEnum.GET_ARCHIVES_FAILURE:
      return { ...state, getArchivesStatus: "FAILURE" }

    case BankArchivesActionsEnum.DOWNLOADING_STATUS_ATTEMPT:
      return { ...state, downloadingStatus: "ATTEMPT" }
    case BankArchivesActionsEnum.DOWNLOADING_STATUS_DOWNLOADING:
      return { ...state, downloadingStatus: "DOWNLOADING" }
    case BankArchivesActionsEnum.DOWNLOADING_STATUS_DOWNLOADED:
      return { ...state, downloadingStatus: "DOWNLOADED" }
    case BankArchivesActionsEnum.DOWNLOADING_STATUS_RESET:
      return { ...state, downloadingStatus: "IDLE" }
    case BankArchivesActionsEnum.DOWNLOADING_STATUS_FAILURE:
      return { ...state, downloadingStatus: "FAILURE" }

    case BankArchivesActionsEnum.GET_TRANSACTION_DATE_BOUNDS_SUCCESS:
      return { ...state, transactionDateBounds: action.payload }
    case BankArchivesActionsEnum.GET_TRANSACTION_DATE_BOUNDS_FAILURE:
      return { ...state, transactionDateBounds: null }

    case BankArchivesActionsEnum.SYNC_BANK_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        operationsStatus: "LOADED",
      }
    case BankArchivesActionsEnum.SYNC_BANK_TRANSACTIONS_ATTEMPT:
      return {
        ...state,
        operationsStatus: "LOADING",
      }
    case BankArchivesActionsEnum.SYNC_BANK_TRANSACTIONS_FAILURE:
      return {
        ...state,
        operationsStatus: "ERROR",
      }
    case BankArchivesActionsEnum.SYNC_BANK_TRANSACTIONS_RESET:
      return {
        ...state,
        operationsStatus: "DEFAULT",
      }

    case BankArchivesActionsEnum.GET_NEW_OPERATIONS_WITHOUT_ARCHIVE_SUCCESS:
      return {
        ...state,
        newOperationsWithoutArchive: action.payload,
      }
    case BankArchivesActionsEnum.GENERATE_ARCHIVE_ATTEMPT: {
      const updatedOperations = state.newOperationsWithoutArchive.map(
        (operation) => {
          if (operation.fiscalYearId === action.fiscalYearId) {
            return { ...operation, status: "GENERATING" as GenerationStatus }
          }
          return operation
        }
      )

      return {
        ...state,
        newOperationsWithoutArchive: updatedOperations,
      }
    }
    case BankArchivesActionsEnum.GENERATE_ARCHIVE_SUCCESS: {
      const updatedOperations = state.newOperationsWithoutArchive.filter(
        (operation) => operation.fiscalYearId !== action.fiscalYearId
      )

      return {
        ...state,
        newOperationsWithoutArchive: updatedOperations,
      }
    }
    case BankArchivesActionsEnum.GENERATE_ARCHIVE_FAILURE: {
      const updatedOperations = state.newOperationsWithoutArchive.map(
        (operation) => {
          if (operation.fiscalYearId === action.fiscalYearId) {
            return { ...operation, status: "NOT_GENERATED" as GenerationStatus }
          }
          return operation
        }
      )

      return {
        ...state,
        newOperationsWithoutArchive: updatedOperations,
      }
    }
    case BankActionsEnum.GET_RULES_SUCCESS: {
      return { ...state, rules: action.rules }
    }
    case BankActionsEnum.GET_RULES_WITHOUT_DOCUMENT_SUCCESS: {
      return { ...state, rulesWithoutDocument: action.rules }
    }
    case BankActionsEnum.GET_DATA_TO_CREATE_RULE_ATTEMPT:
      return { ...state, dataToCreateRule: dataToCreateRuleInitialState }
    case BankActionsEnum.GET_DATA_TO_CREATE_RULE_SUCCESS:
      return { ...state, dataToCreateRule: action.data }
    case BankActionsEnum.GET_DATA_TO_CREATE_RULE_FAILURE:
      return { ...state, dataToCreateRule: dataToCreateRuleInitialState }
    case BankActionsEnum.CREATE_RULE_ATTEMPT:
      return { ...state, createOrEditRuleStatus: "ATTEMPT" }
    case BankActionsEnum.CREATE_RULE_SUCCESS:
      return { ...state, createOrEditRuleStatus: "SUCCESS" }
    case BankActionsEnum.CREATE_RULE_FAILURE:
      return { ...state, createOrEditRuleStatus: "FAILURE" }
    case BankActionsEnum.CREATE_OR_EDIT_RULE_RESET:
      return { ...state, createOrEditRuleStatus: "IDLE" }
    case BankActionsEnum.EDIT_RULE_ATTEMPT:
      return { ...state, createOrEditRuleStatus: "ATTEMPT" }
    case BankActionsEnum.EDIT_RULE_SUCCESS:
      return { ...state, createOrEditRuleStatus: "SUCCESS" }
    case BankActionsEnum.EDIT_RULE_FAILURE:
      return { ...state, createOrEditRuleStatus: "FAILURE" }
    case BankActionsEnum.GET_RULES_EVENTS_SUCCESS: {
      const rules = state.rules.map((rule) => {
        if (rule.id === action.ruleId) {
          return { ...rule, events: action.events }
        }
        return rule
      })
      return { ...state, rules: rules }
    }
    case BankActionsEnum.GET_RULES_WITHOUT_DOCUMENTS_EVENTS_SUCCESS: {
      const rules = state.rulesWithoutDocument.map((rule) => {
        if (rule.id === action.ruleId) {
          return { ...rule, events: action.events }
        }
        return rule
      })
      return { ...state, rulesWithoutDocument: rules }
    }
    case BankActionsEnum.GET_TRANSACTIONS_RESET: {
      return {
        ...state,
        transactions: [],
        getTransactionsStatus: "IDLE",
      }
    }
    case BankActionsEnum.GET_TRANSACTIONS_ATTEMPT: {
      return { ...state, getTransactionsStatus: "ATTEMPT" }
    }
    case BankActionsEnum.GET_TRANSACTIONS_SUCCESS: {
      const initTransactions = action.resetTransactions
        ? action.transactions
        : state.transactions
      const transactions = initTransactions.map((transaction) => {
        let currentTransaction = transaction

        if (!action.resetTransactions) {
          const transactionModified = action.transactions.find(
            (newTransaction) =>
              newTransaction.transaction_id === transaction.transaction_id
          )

          if (!transactionModified) {
            return {
              ...transaction,
              need_action: transaction.need_action,
            }
          } else {
            currentTransaction = transactionModified
          }
        }

        const matchingNeedActionsItem = action.transations_need_action.find(
          (item) => item.transaction_id === currentTransaction.transaction_id
        )
        return {
          ...currentTransaction,
          need_action: matchingNeedActionsItem
            ? matchingNeedActionsItem.need_action
            : false,
        }
      })

      return {
        ...state,
        transactions: transactions,
        getTransactionsStatus: "SUCCESS",
      }
    }
    case BankActionsEnum.GET_TRANSACTIONS_FAILURE:
      return {
        ...state,
        getTransactionsStatus: "FAILURE",
      }

    case BankActionsEnum.TRANSFER_TO_ANOTHER_ACCOUNT_ATTEMPT:
      return {
        ...state,
        transferToStatus: "ATTEMPT",
      }
    case BankActionsEnum.TRANSFER_TO_ANOTHER_ACCOUNT_SUCCESS:
      return {
        ...state,
        transferToStatus: "SUCCESS",
      }
    case BankActionsEnum.TRANSFER_TO_ANOTHER_ACCOUNT_FAILURE:
      return {
        ...state,
        transferToStatus: "FAILURE",
      }
    case BankActionsEnum.CREATE_RULE_FOR_ONE_TRANSACTION_ATTEMPT:
      return {
        ...state,
        createOrEditRuleStatus: "ATTEMPT",
      }
    case BankActionsEnum.CREATE_RULE_FOR_ONE_TRANSACTION_SUCCESS:
      return {
        ...state,
        createOrEditRuleStatus: "SUCCESS",
      }
    case BankActionsEnum.CREATE_RULE_FOR_ONE_TRANSACTION_FAILURE:
      return {
        ...state,
        createOrEditRuleStatus: "FAILURE",
      }
    case FullDocumentsActionsEnum.GET_DOCUMENTS_TO_ATTACH_TO_TRANSACTIONS_ATTEMPT:
      return {
        ...state,
        documentsToAttach: { full_documents: [], batch_data: null },
      }
    case FullDocumentsActionsEnum.GET_DOCUMENTS_TO_ATTACH_TO_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        documentsToAttach: {
          full_documents: action.payload.full_documents,
          batch_data: action.payload.batch_data,
        },
      }
    case FullDocumentsActionsEnum.GET_DOCUMENTS_TO_ATTACH_TO_TRANSACTIONS_RESET:
      return {
        ...state,
        documentsToAttach: { full_documents: [], batch_data: null },
      }
    case FullDocumentsActionsEnum.ATTACH_FULL_DOCUMENT_TO_TRANSACTION_ATTEMPT:
      return { ...state, attachDocumentStatus: "ATTEMPT" }
    case FullDocumentsActionsEnum.ATTACH_FULL_DOCUMENT_TO_TRANSACTION_SUCCESS: {
      return {
        ...state,
        attachDocumentStatus: "SUCCESS",
      }
    }
    case FullDocumentsActionsEnum.ATTACH_FULL_DOCUMENT_TO_TRANSACTION_FAILURE:
      return { ...state, attachDocumentStatus: "FAILURE" }
    case FullDocumentsActionsEnum.ATTACH_FULL_DOCUMENT_TO_TRANSACTION_RESET:
      return { ...state, attachDocumentStatus: "IDLE" }

    case FullDocumentsActionsEnum.DETACH_FULL_DOCUMENT_OF_TRANSACTION_ATTEMPT:
      return { ...state, attachDocumentStatus: "ATTEMPT" }
    case FullDocumentsActionsEnum.DETACH_FULL_DOCUMENT_OF_TRANSACTION_SUCCESS: {
      const transactions = state.transactions?.map((t) => {
        if (t.transaction_id === action.transactionId) {
          return { ...t, batch_document_id: null, full_document_id: null }
        }
        return t
      })

      return {
        ...state,
        transactions: transactions,
        attachDocumentStatus: "SUCCESS",
      }
    }
    case FullDocumentsActionsEnum.DETACH_FULL_DOCUMENT_OF_TRANSACTION_FAILURE:
      return { ...state, attachDocumentStatus: "ATTEMPT" }
    case BankActionsEnum.GET_TRANSACTION_EVENTS_SUCCESS:
      const transactions = state.transactions?.map((t) => {
        if (t.transaction_id === action.transactionId) {
          return { ...t, events: action.events }
        }
        return t
      })
      return { ...state, transactions: transactions }
    case BankActionsEnum.DROP_BATCH_FOR_TRANSACTION_ATTEMPT: {
      return { ...state, attachDocumentStatus: "ATTEMPT" }
    }
    case BankActionsEnum.DROP_BATCH_FOR_TRANSACTION_SUCCESS: {
      const transactions = state.transactions?.map((t) => {
        if (t.transaction_id === action.transactionId) {
          return { ...t, batch_document_id: action.batch_document_id }
        }
        return t
      })

      return {
        ...state,
        transactions: transactions,
        attachDocumentStatus: "SUCCESS",
      }
    }
    case BankActionsEnum.DROP_BATCH_FOR_TRANSACTION_FAILURE: {
      return {
        ...state,
        attachDocumentStatus: "FAILURE",
      }
    }

    case BankArchivesActionsEnum.REGENERATE_BANK_ARCHIVE_ATTEMPT:
      return {
        ...state,
        regenerateBankArchiveStatus: "LOADING",
      }

    case BankArchivesActionsEnum.REGENERATE_BANK_ARCHIVE_SUCCESS:
      return {
        ...state,
        regenerateBankArchiveStatus: "SUCCESS",
      }

    case BankArchivesActionsEnum.REGENERATE_BANK_ARCHIVE_FAILURE:
      return {
        ...state,
        regenerateBankArchiveStatus: "ERROR",
      }

    case BankArchivesActionsEnum.REGENERATE_BANK_ARCHIVE_RESET:
      return {
        ...state,
        regenerateBankArchiveStatus: "IDLE",
      }

    case BankArchivesActionsEnum.DELETE_BANK_ARCHIVE_ATTEMPT:
      return {
        ...state,
        deleteBankArchiveStatus: "LOADING",
      }

    case BankArchivesActionsEnum.DELETE_BANK_ARCHIVE_SUCCESS:
      return {
        ...state,
        deleteBankArchiveStatus: "SUCCESS",
      }

    case BankArchivesActionsEnum.DELETE_BANK_ARCHIVE_FAILURE:
      return {
        ...state,
        deleteBankArchiveStatus: "ERROR",
      }

    case BankArchivesActionsEnum.DELETE_BANK_ARCHIVE_RESET:
      return {
        ...state,
        deleteBankArchiveStatus: "IDLE",
      }

    case BankActionsEnum.GET_URL_FULL_DOCUMENT_ATTEMPT:
      return {
        ...state,
        getUrlFullDocumentToAttachStatus: "ATTEMPT",
      }

    case BankActionsEnum.GET_URL_FULL_DOCUMENT_SUCCESS:
      return {
        ...state,
        getUrlFullDocumentToAttachStatus: "SUCCESS",
        urlFullDocumentToAttach: action.payload,
      }

    case BankActionsEnum.GET_URL_FULL_DOCUMENT_FAILURE:
      return {
        ...state,
        getUrlFullDocumentToAttachStatus: "FAILURE",
        urlFullDocumentToAttach: "",
      }
    case BankActionsEnum.GET_LIST_BANKS_SUCCESS:
      return {
        ...state,
        listBanks: action.listBanks,
      }

    case BankActionsEnum.CREATE_ITEM_WITHOUT_BANKIN_ATTEMPT:
      return {
        ...state,
        createAccountStatus: "ATTEMPT",
      }
    case BankActionsEnum.CREATE_ITEM_WITHOUT_BANKIN_SUCCESS:
      return {
        ...state,
        createAccountStatus: "SUCCESS",
      }
    case BankActionsEnum.CREATE_ITEM_WITHOUT_BANKIN_FAILURE:
      return {
        ...state,
        createAccountStatus: "FAILURE",
      }

    case BankActionsEnum.CREATE_ACCOUNT_WITHOUT_BANKIN_ATTEMPT:
      return {
        ...state,
        createAccountStatus: "ATTEMPT",
      }
    case BankActionsEnum.CREATE_ACCOUNT_WITHOUT_BANKIN_SUCCESS:
      return {
        ...state,
        createAccountStatus: "SUCCESS",
      }
    case BankActionsEnum.CREATE_ACCOUNT_WITHOUT_BANKIN_FAILURE:
      return {
        ...state,
        createAccountStatus: "FAILURE",
      }

    case BankActionsEnum.UPDATE_TRANSACTION_USER_DESCRIPTION_ATTEMPT:
      return {
        ...state,
        updateTransactionUserDescriptionStatus: "ATTEMPT",
      }
    case BankActionsEnum.UPDATE_TRANSACTION_USER_DESCRIPTION_SUCCESS:
      return {
        ...state,
        updateTransactionUserDescriptionStatus: "SUCCESS",
      }
    case BankActionsEnum.UPDATE_TRANSACTION_USER_DESCRIPTION_FAILURE:
      return {
        ...state,
        updateTransactionUserDescriptionStatus: "FAILURE",
      }
    case BankActionsEnum.UPDATE_TRANSACTION_USER_DESCRIPTION_RESET:
      return {
        ...state,
        updateTransactionUserDescriptionStatus: "IDLE",
      }

    default:
      return { ...state }
  }
}

export const getCompanyBanksItemsThunk =
  (fiduciaryId: number, companyId: number) =>
  (dispatch: Dispatch<BankActionsType>) => {
    dispatch(getCompanyBanksItemsAttemptAction())
    return axios
      .get<BankItem[]>(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/list_items`
      )
      .then((response) => {
        dispatch(getCompanyBanksItemsSuccessAction(response.data))
      })
      .catch(() => {
        dispatch(getCompanyBanksItemsFailureAction())
      })
  }

export const addBank =
  (fiduciaryID: number, companyId: number, fiduciaryName: string) =>
  (dispatch: Dispatch<BankActionsType>) => {
    dispatch(addBankAttemptAction())
    return axios
      .get<RedirectedUrl>(
        `/fiduciaries/${fiduciaryID}/companies/${companyId}/redirected_url`
      )
      .then((response) => {
        const url = response.data.redirected_url
        axios
          .post("/users/set_redirect_params", {
            params: {
              readable_safe_url: fiduciaryName,
              id: companyId,
            },
            name: "BankAccounts",
          })
          .then(() => {
            const validUrl = validateUrl(url)
            if (validUrl) {
              window.open(validUrl, "_blank")
              dispatch(addBankSuccessAction())
            } else {
              dispatch(addBankFailureAction())
            }
          })
      })
      .catch(() => {
        dispatch(addBankFailureAction())
      })
  }

export const syncErrorThunk =
  (fiduciaryId: number, companyId: number, id: number, fiduciaryName: string) =>
  (dispatch: Dispatch<BankActionsType>) => {
    dispatch(syncErrorAttemptAction())
    return axios
      .post<RedirectedUrlObject>(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/${id}/edit`
      )
      .then((response) => {
        const url = response.data.redirect_url.redirect_url
        axios
          .post("/users/set_redirect_params", {
            params: {
              readable_safe_url: fiduciaryName,
              id: companyId,
            },
            name: "BankAccounts",
          })
          .then(() => {
            const validUrl = validateUrl(url)
            if (validUrl) {
              window.open(validUrl, "_blank")
              dispatch(syncErrorSuccessAction())
            } else {
              dispatch(syncErrorFailureAction())
            }
          })
      })
      .catch(() => {
        dispatch(syncErrorFailureAction())
      })
  }

export const validateProItemThunk =
  (fiduciaryId: number, companyId: number, id: number, fiduciaryName: string) =>
  (dispatch: Dispatch<BankActionsType>) => {
    dispatch(validateProItemAttemptAction())
    return axios
      .post<RedirectedUrlObject>(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/${id}/validate_pro_items`
      )
      .then((response) => {
        const url = response.data.redirect_url.redirect_url
        axios
          .post("/users/set_redirect_params", {
            params: {
              readable_safe_url: fiduciaryName,
              id: companyId,
            },
            name: "BankAccounts",
          })
          .then(() => {
            const validUrl = validateUrl(url)
            if (validUrl) {
              window.open(validUrl, "_blank")
              dispatch(validateProItemSuccessAction())
            } else {
              dispatch(validateProItemFailureAction())
            }
          })
      })
      .catch(() => {
        dispatch(validateProItemFailureAction())
      })
  }

export const deactivateAccountThunk =
  ({
    fiduciaryId,
    companyId,
    bankItemId,
    bankAccountId,
  }: deactivateAccountParams) =>
  (dispatch: Dispatch<BankActionsType>) => {
    dispatch(deactivateAccountAttempt())
    return axios
      .post(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/${bankItemId}/bank_accounts/${bankAccountId}/deactivate`
      )
      .then(() => dispatch(deactivateAccountSuccess()))
      .catch(() => dispatch(deactivateAccountFailure()))
  }

export const deactivateItemThunk =
  ({ fiduciaryId, companyId, bankItemId }: deactivateItemParams) =>
  (dispatch: Dispatch<BankActionsType>) => {
    dispatch(deactivateItemAttempt())
    return axios
      .post(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/${bankItemId}/destroy_item_data`
      )
      .then(() => dispatch(deactivateItemSuccess()))
      .catch(() => dispatch(deactivateItemFailure()))
  }

export const updateAccountThunk =
  ({
    fiduciaryId,
    companyId,
    bankItemId,
    bankAccountId,
    dataToUpdate,
  }: updateAccountParams) =>
  (dispatch: Dispatch<BankActionsType | RNBThunkAction>) => {
    dispatch(updateAccountSettingsAttempt())
    return axios
      .post(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/${bankItemId}/bank_accounts/${bankAccountId}/update_account_settings`,
        dataToUpdate
      )
      .then(() => {
        dispatch(updateAccountSettingsSuccess())
        if (companyId && bankItemId) {
          dispatch(getCompanyBanksItemsThunk(fiduciaryId, companyId))
        }
      })
      .catch((response) => {
        let errorMessage = response.response.data.error

        errorMessage = errorMessage
          .replace(
            /Bankin journal code |Impossible de sauvegarder : |Bankin financial account |Bankin suspense account |Bank paper iban /gi,
            ""
          )
          .replaceAll(",", ".")

        return dispatch(updateAccountSettingsFailure(errorMessage))
      })
  }

export const getRulesThunk =
  (bankAccountId: number) => (dispatch: Dispatch<BankActionsType>) => {
    dispatch(GetRulesAttempt())
    return axios
      .get<AccountRules[]>(`/bank_accounts/${bankAccountId}/get_account_rules`)
      .then((response) => {
        dispatch(GetRulesSuccess(bankAccountId, response.data))
      })
      .catch(() => {
        dispatch(GetRulesFailure())
      })
  }

export const getRulesWithoutDocumentThunk =
  (bankAccountId: number) => (dispatch: Dispatch<BankActionsType>) => {
    dispatch(GetRulesWithoutDocumentAttempt())
    return axios
      .get<AccountRulesWithoutDocument[]>(
        `/bank_accounts/${bankAccountId}/get_account_rules_without_document`
      )
      .then((response) => {
        dispatch(GetRulesWithoutDocumentSuccess(bankAccountId, response.data))
      })
      .catch(() => {
        dispatch(GetRulesWithoutDocumentFailure())
      })
  }

export const getDataToCreateRuleThunk =
  (bankAccountId: number) => (dispatch: Dispatch<BankActionsType>) => {
    dispatch(GetDataToCreateRuleAttempt())
    return axios
      .get<DataToCreateRule>(
        `/bank_accounts/${bankAccountId}/get_data_to_create_rule`
      )
      .then((response) => {
        dispatch(GetDataToCreateRuleSuccess(response.data))
      })
      .catch(() => {
        dispatch(GetDataToCreateRuleFailure())
      })
  }

export const createRuleThunk =
  (
    newRule: NewRuleParams,
    bankAccountId: number,
    from: "rules" | "transactions" | "rule_without_document"
  ) =>
  (dispatch: Dispatch<BankActionsType | RNBThunkAction>) => {
    dispatch(CreateRuleAttempt())
    return axios
      .post(`/bank_accounts/${bankAccountId}/create_rule`, {
        new_rule: newRule,
        rule_without_document: from === "rule_without_document",
      })
      .then(() => {
        dispatch(CreateRuleSuccess())
        if (from === "rules") {
          dispatch(getRulesThunk(bankAccountId))
        } else if (from === "transactions") {
          dispatch(getDataToCreateRuleThunk(bankAccountId))
          dispatch(GetTransactionsThunk(bankAccountId, undefined, false))
        } else if (from === "rule_without_document") {
          dispatch(getRulesWithoutDocumentThunk(bankAccountId))
        }
      })
      .catch((error) => {
        let message = "bank-management.rules.add-rule.error.message"
        if (
          error.response.data.error.includes(
            "Another rule already exists with same params"
          )
        ) {
          message = "bank-management.rules.add-rule.error.message.duplicate"
        }
        dispatch(CreateRuleFailure(message))
      })
  }

export const EditRuleThunk =
  (
    editedRule: NewRuleParams,
    bankAccountId: number,
    ruleId: number,
    rule_without_document: boolean
  ) =>
  (dispatch: Dispatch<BankActionsType | RNBThunkAction>) => {
    dispatch(EditRuleAttempt())
    return axios
      .post(`/bank_accounts/${bankAccountId}/edit_rule`, {
        edited_rule: editedRule,
        rule_id: ruleId,
        rule_without_document: rule_without_document,
      })
      .then(() => {
        dispatch(EditRuleSuccess())
        if (rule_without_document) {
          dispatch(getRulesWithoutDocumentThunk(bankAccountId))
        } else {
          dispatch(getRulesThunk(bankAccountId))
        }
      })
      .catch((error) => {
        let message = "bank-management.rules.add-rule.error.message"
        if (
          error.response.data.error.includes(
            "Another rule already exists with same params"
          )
        ) {
          message = "bank-management.rules.add-rule.error.message.duplicate"
        }
        dispatch(EditRuleFailure(message))
      })
  }

export const GetRuleEventsThunk =
  (bankAccountId: number, ruleId: number, rule_without_document: boolean) =>
  (dispatch: Dispatch<BankActionsType>) => {
    dispatch(GetRuleEventsAttempt())
    return axios
      .get<RuleEvent[]>(`/bank_accounts/${bankAccountId}/get_rule_events`, {
        params: { rule_id: ruleId },
      })
      .then((response) => {
        if (rule_without_document) {
          dispatch(
            GetRuleWithoutDocumentEventsSuccess(
              response.data,
              bankAccountId,
              ruleId
            )
          )
        } else {
          dispatch(GetRuleEventsSuccess(response.data, bankAccountId, ruleId))
        }
      })
      .catch(() => {
        dispatch(GetRuleEventsFailure())
      })
  }

export const DeleteRuleThunk =
  (
    bankAccountId: number,
    ruleId: number,
    from: "rules" | "transactions" | "rule_without_document"
  ) =>
  (dispatch: Dispatch<BankActionsType | RNBThunkAction>) => {
    dispatch(DeleteRuleAttempt())
    return axios
      .post(`/bank_accounts/${bankAccountId}/destroy_rule`, {
        rule_id: ruleId,
        rule_without_document: from === "rule_without_document",
      })
      .then(() => {
        dispatch(DeleteRuleSuccess(from === "rule_without_document"))
        if (from === "rules") {
          dispatch(getRulesThunk(bankAccountId))
        } else if (from === "transactions") {
          dispatch(getDataToCreateRuleThunk(bankAccountId))
        } else if (from === "rule_without_document") {
          dispatch(getRulesWithoutDocumentThunk(bankAccountId))
        }
      })
      .catch(() => {
        dispatch(DeleteRuleFailure())
      })
  }

export const GetTransactionsThunk =
  (
    bankAccountId: number,
    transactionIds?: number[],
    resetTransactions: boolean = true,
    excludeTransactionsLinkedToBatch: boolean = false
  ) =>
  (dispatch: Dispatch<BankActionsType>) => {
    const needToResetTransactions =
      transactionIds && transactionIds.length > 0 ? false : resetTransactions

    if (needToResetTransactions) {
      dispatch(GetTranscationsReset(bankAccountId))
    }

    dispatch(GetTranscationsAttempt(bankAccountId))
    return axios
      .get<Transaction[]>(
        `/bank_accounts/${bankAccountId}/get_transactions_with_rules`,
        {
          params: {
            transaction_ids: transactionIds,
            exclude_transactions_linked_to_batch:
              excludeTransactionsLinkedToBatch,
          },
        }
      )
      .then(({ data }) => {
        const transactions = data
        axios
          .get<{ transaction_id: number; need_action: boolean }[]>(
            `/bank_accounts/${bankAccountId}/get_batch_states_of_transactions`,
            {
              params: { transaction_ids: transactionIds },
            }
          )
          .then((response) => {
            dispatch(
              GetTranscationsSuccess(
                transactions,
                response.data,
                bankAccountId,
                needToResetTransactions
              )
            )
          })
      })
      .catch(() => {
        dispatch(GetTranscationsFailure())
      })
  }

export const TransferRuleToAnotherAccountThunk =
  (
    bankAccountId: number,
    transfer_to: number,
    rule_without_document: boolean
  ) =>
  (dispatch: Dispatch<BankActionsType>) => {
    dispatch(TransferToAnotherAccountAttempt())
    const url = rule_without_document
      ? `/bank_accounts/${bankAccountId}/transfer_rules_without_document_to_another_account`
      : `/bank_accounts/${bankAccountId}/transfer_rules_to_another_account`
    return axios
      .post(url, {
        transfer_to: transfer_to,
      })
      .then(() => {
        dispatch(TransferToAnotherAccountSuccess())
      })
      .catch(() => {
        dispatch(TransferToAnotherAccountFailure())
      })
  }

export const CreateRuleForOneTransactionThunk =
  (newRule: NewRuleParams, bankAccountId: number, transactionId: number) =>
  (dispatch: Dispatch<BankActionsType | RNBThunkAction>) => {
    dispatch(CreateRuleForOneTransactionAttempt())
    return axios
      .post(`/bank_accounts/${bankAccountId}/create_rule_for_one_transaction`, {
        new_rule: newRule,
        transaction_id: transactionId,
      })
      .then(() => {
        dispatch(CreateRuleForOneTransactionSuccess())
        dispatch(getDataToCreateRuleThunk(bankAccountId))
        dispatch(GetTransactionsThunk(bankAccountId, [transactionId]))
      })
      .catch(() => {
        dispatch(CreateRuleForOneTransactionFailure())
      })
  }

export const MarkWithoutDocumentThunk =
  (
    bankAccountId: number,
    transactionId: number,
    marked_without_document: boolean
  ) =>
  (dispatch: Dispatch<BankActionsType | RNBThunkAction>) => {
    dispatch(MarkWithoutDocumentAttempt())
    return axios
      .post(
        `/bank_accounts/${bankAccountId}/mark_transaction_without_document`,
        {
          transaction_id: transactionId,
          marked_without_document: marked_without_document,
        }
      )
      .then(() => {
        dispatch(MarkWithoutDocumentSuccess(marked_without_document))
        dispatch(GetTransactionsThunk(bankAccountId, [transactionId]))
      })
      .catch((error) => {
        let message =
          "bank-management.rules-without-document.marked_without_document.error.message"
        if (
          error.response.data.error.includes(
            "error transaction has a document attached"
          )
        ) {
          message += "-full-doc"
        } else if (
          error.response.data.error.includes(
            "error transaction is in a archive"
          )
        ) {
          message += "-archive"
        }
        dispatch(MarkWithoutDocumentFailure(message))
      })
  }

export const GetTransactionEventsThunk =
  (bankAccountId: number, transaction_id: number) =>
  (dispatch: Dispatch<BankActionsType>) => {
    dispatch(GetTransactionEventsAttempt())
    return axios
      .get<TransactionEvent[]>(
        `/bank_accounts/${bankAccountId}/get_transaction_events`,
        {
          params: { transaction_id: transaction_id },
        }
      )
      .then((response) => {
        dispatch(
          GetTransactionEventsSuccess(
            response.data,
            bankAccountId,
            transaction_id
          )
        )
      })
      .catch(() => {
        dispatch(GetTranscationsFailure())
      })
  }

export const DropBatchForTransactionThunk =
  (
    bankAccountId: number,
    transactionId: number,
    originalFileName: string,
    originalFileSize: number,
    fingerprint: string,
    file: File,
    selectedCompanyId: number
  ) =>
  (dispatch: Dispatch<AnyAction> & ThunkDispatch<RootState, {}, AnyAction>) => {
    dispatch(DropBatchForTransactionAttempt())

    const config = (extension: string | null) => {
      const headers =
        extension && acceptedBatchExtensions.includes(extension)
          ? {
              headers: {
                "Content-type":
                  extension === "pdf"
                    ? "application/pdf"
                    : ["jpg", "jpeg"].includes(extension)
                    ? "image/jpeg"
                    : ["tiff", "tif"].includes(extension)
                    ? "image/tiff"
                    : "image/png",
              },
            }
          : {}

      return {
        withCredentials: false,
        ...headers,
      }
    }

    axios
      .post<DropDocumentResultPayload>(`/batch_documents`, {
        company_id: selectedCompanyId,
        fingerprint: fingerprint,
        original_file_name: originalFileName,
        original_file_size: originalFileSize,
      })
      .then(({ data }) => {
        let id = data.obj_id
        signRequest(id).then((res) => {
          axios
            .put(
              res.data.put_url,
              file,
              config(fileExtensionOfString(originalFileName))
            )
            .then(() => {
              axios.put(`/batch_documents/trigger_split`, {
                id: id,
              })
            })
            .then(() => {
              dispatch(
                AttachBatchOnTransactionThunk(
                  bankAccountId,
                  transactionId,
                  id,
                  selectedCompanyId,
                  "drop"
                )
              )
            })
            .then(() => {
              setTimeout(() => {
                dispatch(
                  GetDocumentsToAttachToTransactionsThunk(
                    bankAccountId,
                    selectedCompanyId,
                    transactionId,
                    true,
                    true
                  )
                )
                dispatch(
                  DropBatchForTransactionSuccess(
                    bankAccountId,
                    transactionId,
                    id
                  )
                )
              }, 1000)
            })
        })
      })
      .catch(() => {
        dispatch(DropBatchForTransactionFailure())
      })
  }

export const AttachBatchOnTransactionThunk =
  (
    bankAccountId: number,
    transactionId: number,
    batch_document_id: number,
    companyId: number,
    from: "drop" | "attachOriginal"
  ) =>
  (dispatch: Dispatch<BankActionsType | RNBThunkAction>) => {
    dispatch(AttachBatchOnTransactionAttempt())
    return axios
      .post(
        `/bank_accounts/${bankAccountId}/add_batch_document_on_transaction`,
        {
          transaction_id: transactionId,
          batch_document_id: batch_document_id,
        }
      )
      .then(() => {
        dispatch(AttachBatchOnTransactionSuccess())
        if (from === "attachOriginal") {
          dispatch(GetTransactionsThunk(bankAccountId, [transactionId]))
          dispatch(
            GetDocumentsToAttachToTransactionsThunk(
              bankAccountId,
              companyId,
              transactionId,
              true,
              true
            )
          )
        }
      })
      .catch(() => {
        dispatch(AttachBatchOnTransactionFailure())
      })
  }

export const getUrlFullDocumentBankThunk =
  (fullDocumentId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getUrlFullDocumentAttempt())
    return axios
      .get<string>("/full_documents/get_url_for_full_document", {
        params: { id: fullDocumentId },
      })
      .then((response) => {
        dispatch(getUrlFullDocumentSuccess(response.data))
      })
      .catch(() => {
        dispatch(getUrlFullDocumentFailure())
      })
  }

export const GetListBankThunk =
  (fiduciaryId: number, companyId: number) =>
  (dispatch: Dispatch<BankActionsType>) => {
    dispatch(getListBanksAttempt())
    return axios
      .get<ListBank[]>(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/list_banks`
      )
      .then((response) => {
        dispatch(getListBanksSuccess(response.data))
      })
      .catch(() => {
        dispatch(getListBanksFailure())
      })
  }

export const createItemWithoutBankinThunk =
  (
    fiduciaryId: number,
    companyId: number,
    bank_name: string,
    bank_id: number | null,
    account_name: string,
    account_number: string,
    journal_code: string,
    financial_account: string,
    suspense_account: string
  ) =>
  (dispatch: Dispatch<BankActionsType | RNBThunkAction>) => {
    dispatch(createItemWithoutBankinAttempt())
    return axios
      .post(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/create_item_without_bankin`,
        {
          bank_name: bank_name,
          bank_id: bank_id,
          account_name: account_name,
          account_number: account_number,
          journal_code: journal_code,
          financial_account: financial_account,
          suspense_account: suspense_account,
        }
      )
      .then(() => {
        dispatch(createItemWithoutBankinSuccess())
        dispatch(getCompanyBanksItemsThunk(fiduciaryId, companyId))
      })
      .catch((response) => {
        let errorMessage = response.response.data.error

        errorMessage = errorMessage
          .replace(
            /Bankin journal code |Impossible de sauvegarder : |Bankin financial account |Bankin suspense account |Bank paper iban /gi,
            ""
          )
          .replaceAll(",", ".")
        dispatch(createItemWithoutBankinFailure(errorMessage))
      })
  }

export const createAccountWithoutBankinThunk =
  (
    fiduciaryId: number,
    companyId: number,
    id: number,
    account_name: string,
    account_number: string,
    journal_code: string,
    financial_account: string,
    suspense_account: string
  ) =>
  (dispatch: Dispatch<BankActionsType | RNBThunkAction>) => {
    dispatch(createAccountWithoutBankinAttempt())
    return axios
      .post(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/${id}/create_account_without_bankin`,
        {
          account_name: account_name,
          account_number: account_number,
          journal_code: journal_code,
          financial_account: financial_account,
          suspense_account: suspense_account,
        }
      )
      .then((response) => {
        dispatch(createAccountWithoutBankinSuccess())
        dispatch(getCompanyBanksItemsThunk(fiduciaryId, companyId))
      })
      .catch((response) => {
        let errorMessage = response.response.data.error

        errorMessage = errorMessage
          .replace(
            /Bankin journal code |Impossible de sauvegarder : |Bankin financial account |Bankin suspense account |Bank paper iban /gi,
            ""
          )
          .replaceAll(",", ".")
        dispatch(createAccountWithoutBankinFailure(errorMessage))
      })
  }

export const updateTransactionUserDescriptionThunk =
  (bankAccountId: number, transactionId: number, userDescription: string) =>
  (dispatch: Dispatch<BankActionsType | RNBThunkAction>) => {
    dispatch(updateTransactionUserDescriptionAttempt())
    return axios
      .post(
        `/bank_transactions/${transactionId}/update_transaction_user_description`,
        { user_description: userDescription }
      )
      .then(() => {
        dispatch(GetTransactionsThunk(bankAccountId, [transactionId]))
        dispatch(updateTransactionUserDescriptionSuccess())
      })
      .catch(() => dispatch(updateTransactionUserDescriptionFailure()))
  }

export type BankLineType = "in" | "out"
export type CompareAmountType = "greater" | "lesser" | "equal" | null
export type PrefixType = "401" | "411" | "6" | "7"

export interface NewRuleParams {
  account_id: number | null
  amount?: number | null
  bank_line_type?: BankLineType
  compare_amount?: CompareAmountType
  merchant_code_id: number | null
  prefix: PrefixType | null
  priority_number?: number | null
  text_in_description: string | null
  vat_rate_id: number | null
  id?: number
}

interface RedirectedUrl {
  redirected_url: string
}

interface RedirectedUrlObject {
  redirect_url: { redirect_url: string }
}

export interface updateAccountData {
  name?: string
  first_import_date?: string
  bank_journal_code?: number
  bank_financial_account?: number
  bank_suspense_account?: number
  bank_paper_iban?: string
}
export interface updateAccountParams {
  fiduciaryId: number
  companyId: number
  bankItemId: number
  bankAccountId: number
  dataToUpdate: updateAccountData
}

interface deactivateItemParams {
  fiduciaryId: number
  companyId: number | null
  bankItemId: number | null
}

interface deactivateAccountParams {
  fiduciaryId: number
  companyId: number | null
  bankItemId: number | null
  bankAccountId: number | null
}

export interface AccountRules {
  bank_account_id: number
  priority_number: number
  bank_line_type: BankLineType
  amount: number | null
  compare_amount: CompareAmountType
  text_in_description: string | null
  prefix: PrefixType
  value_account: string
  company_prefix: string
  third_party: string | null
  rate: string | null
  value_account_id: number | null
  id: number
  events: RuleEvent[]
  transaction_id: number | null
  rule_without_document: boolean
  is_ai_rule: boolean
}

export interface AccountRulesWithoutDocument {
  bank_account_id: number
  bank_line_type: BankLineType
  amount: number | null
  compare_amount: CompareAmountType
  text_in_description: string | null
  id: number
  events: RuleEvent[]
  transaction_id: number | null
  rule_without_document: boolean
  priority_number: null
}

export interface DataToCreateRule {
  merchant_codes: {
    id: number
    code: string
    auxiliary: boolean
  }[]
  accounts: AccountToCreateRule[]
  vat_rates: {
    id: number
    rate: number
  }[]
  company_data: {
    buy_auxiliary_prefix: string | null
    sell_auxiliary_prefix: string | null
    buy_third_party_account: string | null
    sell_third_party_account: string | null
  } | null
  rules: AccountRules[]
  rules_without_document: AccountRulesWithoutDocument[]
}

export interface AccountToCreateRule {
  id: number
  number: string
  details: string
}

export interface RuleEvent {
  email: string
  event_type: "create_rule" | "edit_rule"
  metadata: { [index: string]: string }
  created_at: string
}

export interface TransactionEvent {
  email: string
  event_type:
    | "marked_without_document"
    | "remove_marked_without_document"
    | "attach_document"
    | "detach_document"
    | "create_uniq_rule"
    | "update_description"
  metadata: { [index: string]: string }
  created_at: string
}

export interface Transaction {
  transaction_id: number
  date: string
  description: string
  user_description: string | null
  possible_rules?: number[]
  lines: Line[]
  rule_id?: number | null
  is_ai_rule: boolean
  full_document_id: number | null
  document_type?: "invoice" | "credit_note" | null
  amount_type: "positive" | "negative"
  fd_deactivated: boolean
  marked_without_document: boolean
  events: TransactionEvent[]
  rule_without_document_id: number | null
  batch_document_id: number | null
  need_action: boolean
  amount: number
  bank_paper_iban: string | null
  bank_receipt_paper_number: string | null
  toolbox_assignment_status: "unprocessed" | "pending" | "finished" | null
}

export interface Line {
  amount: number
  vat_rate?: number | null
  assignment?: string
  auxiliary_assignment?: string
  direction?: "debit" | "credit"
}

interface ListBank {
  id: number
  name: string
}
